import { render } from "./CardStructureSymabio.vue?vue&type=template&id=fbdec2ac"
import script from "./CardStructureSymabio.vue?vue&type=script&lang=js"
export * from "./CardStructureSymabio.vue?vue&type=script&lang=js"

import "./CardStructureSymabio.vue?vue&type=style&index=0&id=fbdec2ac&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__